function deeplinkBaseUrlState(state) {
  const { browser, deeplinkUrls } = state.env
  if (!browser.get('native')) {
    if (browser.get('android')) {
      return deeplinkUrls.get('android')
    }
    if (browser.get('ios')) {
      return deeplinkUrls.get('ios')
    }
  }
}

function isVisibleState(state) {
  return (
    !!deeplinkBaseUrlState(state) &&
    !state.env.nativeEmbedded &&
    !state.env.openInAppDismissed
  )
}

// Exports

module.exports = {
  deeplinkBaseUrlState,
  isVisibleState
}
